import React from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import InfoListRow from '../orderDetailsSection/tankdetailsFarmAndRanch/components/infoListRow';
import { TankDetailsMain, DetailsGrid, DetailsSectionHeader } from './css';

const SummaryTankDetailsFarmAndRanch = ({ tankDetails }) => {
  const availableTankDetails = tankDetails.filter(
    item => item.details.length > 0
  );
  if (availableTankDetails.length === 0) return null;

  return (
    <>
      <Typography heading="h4" variant={{ size: 'h4' }} block>Tank Details</Typography>
      <TankDetailsMain>
        {availableTankDetails.map(item => {
          const { title, key, details } = item;
          return (
            <div>
              <DetailsSectionHeader>{title}</DetailsSectionHeader>
              <DetailsGrid>
                {details.map((detail, index) => (
                  <InfoListRow
                    showDelete={false}
                    typeKey={key}
                    row={detail}
                    rowIndex={index}
                  />
                ))}
              </DetailsGrid>
            </div>
          );
        })}
      </TankDetailsMain>
    </>
  );
};

SummaryTankDetailsFarmAndRanch.propTypes = {
  tankDetails: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default SummaryTankDetailsFarmAndRanch;
